/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentPromotionCodeResponseData,
  GetOrganizationPaymentPromotionCodeResponseDataFromJSON,
  GetOrganizationPaymentPromotionCodeResponseDataFromJSONTyped,
  GetOrganizationPaymentPromotionCodeResponseDataToJSON
} from './GetOrganizationPaymentPromotionCodeResponseData'

/**
 *
 * @export
 * @interface GetOrganizationPaymentPromotionCodeResponse
 */
export interface GetOrganizationPaymentPromotionCodeResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationPaymentPromotionCodeResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentPromotionCodeResponseData}
   * @memberof GetOrganizationPaymentPromotionCodeResponse
   */
  data: GetOrganizationPaymentPromotionCodeResponseData
}

export function GetOrganizationPaymentPromotionCodeResponseFromJSON(
  json: any
): GetOrganizationPaymentPromotionCodeResponse {
  return GetOrganizationPaymentPromotionCodeResponseFromJSONTyped(json, false)
}

export function GetOrganizationPaymentPromotionCodeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationPaymentPromotionCodeResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentPromotionCodeResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationPaymentPromotionCodeResponseToJSON(
  value?: GetOrganizationPaymentPromotionCodeResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentPromotionCodeResponseDataToJSON(value.data)
  }
}
